import { jsx as i, jsxs as n } from "react/jsx-runtime";
import { useMemo as c } from "react";
import t from "styled-components";
import r from "../../../utils/colors.js";
import { device as e } from "../../../utils/device.js";
import p from "./Feedback.js";
import d from "./Link.js";
const l = [
  { text: "Our Services", link: "https://service.vic.gov.au/find-services" },
  { text: "Careers", link: "https://careers.vic.gov.au/jobs/premier-and-cabinet/service-victoria" },
  { text: "Accessibility", link: "https://service.vic.gov.au/accessibility" },
  { text: "Terms of use", link: "https://service.vic.gov.au/terms-of-use" },
  { text: "Copyright", link: "https://service.vic.gov.au/copyright" },
  { text: "Privacy and security", link: "https://service.vic.gov.au/privacy-and-security" }
], m = t.div`
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid ${r.darkGrey75};

  @media ${e.isTablet} {
    width: 95vw;
    align-items: stretch;
    justify-content: center;
    flex-wrap: unset;
  }

  @media ${e.isDesktop} {
    width: 960px;
    margin: auto;
  }
`, v = t.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  transform: translateY(1px);

  padding: 40px 20px;
  line-height: 1.05rem;
  border-bottom: 1px solid ${r.darkGrey75};

  @media ${e.isTablet} {
    padding: 0;
    flex: 0 50%;
    flex-wrap: wrap;
    padding: 5rem 0 2rem;
  }

  @media ${e.isDesktop} {
    padding: 6rem 0 3rem 0;
  }
`, u = t.div`
  transition: all 0.1s ease-in-out;
  background: transparent;
  transition: color 0.1s ease-in-out;
  outline-color: ${r.white};
  padding: 20px;

  @media ${e.isTablet} {
    padding: 0;
    flex: 0 50%;
    padding: 5rem 0 2rem;
  }

  @media ${e.isDesktop} {
    padding: 6rem 0 3rem 3rem;
  }
`, w = () => {
  const a = c(() => l.map(({ link: o, text: s }) => /* @__PURE__ */ i(d, { link: o, text: s }, s)), []);
  return /* @__PURE__ */ n(m, { children: [
    /* @__PURE__ */ i(v, { children: a }),
    /* @__PURE__ */ i(u, { children: /* @__PURE__ */ i(
      p,
      {
        title: "Give feedback",
        subtitle: "Tell us about your experience",
        link: "https://service.vic.gov.au/contact/send-us-a-message"
      }
    ) })
  ] });
};
export {
  w as default
};
